var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.IsShowMask)?_c('div',{staticClass:"c-mask"},[_c('div',{staticClass:"common-mask-bg"},[_c('c-carousel',{on:{"closeMask":_vm.closeMask}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }